import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import * as Actions from '../../actions';
import * as Constants from '../../constants';
import { AriaAttributes } from '../../constants/AccessibilityConstants';
import { jeCSS } from '../../lib/StyleUtils';

import { ModalBody, ModalButtonRow, ModalContainer, ModalTitle, ModalXRow } from './Modal';

import './ModalCoachMark.scss';

export class ModalCoachMark extends React.Component {
  static propTypes = {
    title: PropTypes.node,
    body: PropTypes.node,
    onClose: PropTypes.func,
    buttons: PropTypes.arrayOf(PropTypes.element),
    timeout: PropTypes.number,
    styleNames: PropTypes.array,
    id: PropTypes.string,
    componentViewed: PropTypes.func.isRequired,
    coachmarkClicked: PropTypes.func.isRequired,
  };

  static defaultProps = {
    timeout: 7000,
  };

  componentDidMount() {
    const coachmarkType = this.props.id;
    if (coachmarkType) {
      this.props.componentViewed({ coachmarkType });
    }
  }

  componentWillUnmount() {
    this.props.onClose();
    clearTimeout(this.timeoutId);
  }

  closeCoachmark = () => {
    const modalCoachMarkType = this.props.id;
    if (modalCoachMarkType) {
      this.props.coachmarkClicked(modalCoachMarkType, Constants.Stats.CoachmarkReasons.DISMISSED);
    }
  };

  onCloseClick = () => {
    this.closeCoachmark();
    this.props.onClose();
  };

  render() {
    const { title, body, buttons } = this.props;
    const ariaAttributes = {};
    ariaAttributes[AriaAttributes.LIVE] = 'polite';

    if (this.props.timeout) {
      clearTimeout(this.timeoutId); // prevent previous timeout from closing current coachmark
      this.timeoutId = setTimeout(() => {
        this.props.onClose();
      }, this.props.timeout);
    }

    let styleNames = [];
    if (buttons && buttons.length) {
      styleNames = styleNames.concat('withButton');
    }
    if (this.props.styleNames) {
      styleNames = styleNames.concat(this.props.styleNames);
    }

    const classes = jeCSS('Modal--coachmark', styleNames);

    return (
      <ModalContainer className={classes}>
        <ModalXRow onClose={this.onCloseClick} />
        {title ? <ModalTitle>{title}</ModalTitle> : null}
        {body ? (
          <ModalBody>
            <span {...ariaAttributes}>{body}</span>
          </ModalBody>
        ) : null}
        {buttons && buttons.length ? <ModalButtonRow buttons={buttons} /> : null}
      </ModalContainer>
    );
  }
}

const mapDispatchToProps = {
  componentViewed: Actions.Integrations.componentViewed,
  coachmarkClicked: Actions.MiniCoachmark.coachmarkClicked,
};

export default connect(null, mapDispatchToProps)(ModalCoachMark);
